<form
  [formGroup]="form"
  [ngClass]="{ 'form': selectCatalog?.hasGeo, 'form-without-map': !selectCatalog?.hasGeo }"
  *ngLet="selectCatalog$ | async as selectCatalog"
>
  <div [class.impaired]="isImpaired" class="row" *ngLet="resetMap$ | async">
    <button *ngIf="(breakPointObserve$ | async)?.matches && selectCatalog?.hasGeo" class="btn-empty detail-btn" type="button" (click)="showMobileMap = !showMobileMap">
      <svg [icon]="icons.Location" class="svg24 primary-color mr4" />
      <span class="link-6">{{ 'OTHER.TO_SHOW_ON_THE_MAP' | translate }}</span>
    </button>

    <mat-form-field *ngIf="!isImpaired" appearance="outline" class="appeal-input">
      <mat-label>{{ 'OTHER.DATASET_NAME' | translate }}</mat-label>
      <input  class="catalog-name" matInput formControlName="nameCatalog" [ngModel]="selectCatalog?.catalogName" />
    </mat-form-field>

    <app-impaired-input
      *ngIf="isImpaired"
      placeholder="{{ 'OTHER.WRITE' | translate }} {{ ('VERSION_VISUALLY_IMPAIRED.DATASET_NAME' | translate)?.toLowerCase() }}"
      header="{{ 'OTHER.DATASET_NAME' | translate }}"
      [control]="$any(form.controls.nameCatalog)"
      [defaultValue]="selectCatalog?.catalogName"
    ></app-impaired-input>

    <mat-form-field *ngIf="!isImpaired" appearance="outline" class="appeal-input">
      <mat-label>{{ 'DATA.SHARED.APPEALS.NAME_NEW_ITEM' | translate }}</mat-label>
      <input
             autocomplete="off" matInput formControlName="nameItem" />
    </mat-form-field>

    <app-impaired-input
      *ngIf="isImpaired"
      placeholder="{{ 'OTHER.WRITE' | translate }} {{ ('VERSION_VISUALLY_IMPAIRED.DATASET_NAME' | translate)?.toLowerCase() }}"
      header="{{ 'DATA.SHARED.APPEALS.NAME_NEW_ITEM' | translate }}"
      [control]="$any(form.controls.nameItem)"
    ></app-impaired-input>

    <mat-form-field *ngIf="!isImpaired && selectCatalog?.hasGeo" appearance="outline" class="appeal-textarea">
      <mat-label>{{ 'DATA.SHARED.APPEALS.ADDRESS' | translate }}</mat-label>
      <textarea matInput formControlName="address"></textarea>
    </mat-form-field>

    <app-impaired-input
      *ngIf="isImpaired && selectCatalog?.hasGeo"
      placeholder="{{ 'VERSION_VISUALLY_IMPAIRED.INDICATE' | translate }} {{ ('DATA.SHARED.APPEALS.ADDRESS' | translate)?.toLowerCase() }}"
      header="{{ 'DATA.SHARED.APPEALS.ADDRESS' | translate }}"
      [control]="$any(form.controls.address)"
      [type]="'textarea'"
    ></app-impaired-input>

    <mat-form-field *ngIf="!isImpaired" appearance="outline" class="appeal-textarea">
      <mat-label>{{ 'OTHER.COMMENTS' | translate }}</mat-label>
      <textarea matInput formControlName="comment"></textarea>
    </mat-form-field>

    <app-impaired-input
      *ngIf="isImpaired"
      placeholder="{{ 'OTHER.WRITE' | translate }} {{ ('OTHER.COMMENTS' | translate)?.toLowerCase() }}"
      header="{{ 'OTHER.COMMENTS' | translate }}"
      [control]="$any(form.controls.comment)"
      [type]="'textarea'"
    ></app-impaired-input>

    <mat-form-field *ngIf="!isImpaired && selectCatalog?.hasGeo" appearance="outline" class="appeal-input">
      <mat-label>{{ 'DATA.SHARED.APPEALS.X_COORDINATE' | translate }}</mat-label>
      <input matInput type="number" formControlName="coordinateX" />
    </mat-form-field>

    <app-impaired-input
      *ngIf="isImpaired && selectCatalog?.hasGeo"
      placeholder="{{ 'VERSION_VISUALLY_IMPAIRED.INDICATE' | translate }} {{ 'VERSION_VISUALLY_IMPAIRED.X_COORDINATE' | translate }}"
      header="{{ 'DATA.SHARED.APPEALS.X_COORDINATE' | translate }}"
      [type]="'number'"
      [control]="$any(form.controls.coordinateX)"
    ></app-impaired-input>

    <mat-form-field *ngIf="!isImpaired && selectCatalog?.hasGeo" appearance="outline" class="appeal-input">
      <mat-label>{{ 'DATA.SHARED.APPEALS.Y_COORDINATE' | translate }}</mat-label>
      <input type="number" matInput formControlName="coordinateY" />
    </mat-form-field>

    <app-impaired-input
      *ngIf="isImpaired && selectCatalog?.hasGeo"
      placeholder="{{ 'VERSION_VISUALLY_IMPAIRED.INDICATE' | translate }} {{ 'VERSION_VISUALLY_IMPAIRED.Y_COORDINATE' | translate }}"
      header="{{ 'DATA.SHARED.APPEALS.Y_COORDINATE' | translate }}"
      [type]="'number'"
      [control]="$any(form.controls.coordinateY)"
    ></app-impaired-input>
  </div>

  <div class="map"  *ngIf="selectCatalog?.hasGeo" [class.mobile-map-open]="showMobileMap">
    <button class="btn-empty closer" *ngIf="showMobileMap" (click)="showMobileMap = false">
      <svg [icon]="icons.Close" class="svg24 dark-gray-color" />
    </button>

    <input
      [placeholder]="['DATA.SHARED.APPEALS.ADDRESS_NOT_SELECTED' | translate]"
      readOnly
      class="mobile-input"
      formControlName="address"
      *ngIf="showMobileMap"
    />

    <app-map
      [onePoint]="true"
      *ngIf="showMap"
      [controlRight]="isImpaired"
      [isImpaired]="isImpaired"
      [pointIcon]="'/assets/svg/location.svg'"
      [pointIconSize]="[34, 34]"
      [showZoomControl]="!showMobileMap"
      [showFullScreenButton]="false"
      (clickOnMapEvent)="setCoordinates($event)"
    ></app-map>
    <div class="footer mt32 mb24 map-footer" *ngIf="showMobileMap">
      <div class="buttons-wrapper">
        <button class="btn-secondary medium mr16" (click)="cancelMobileMap()">{{ 'OTHER.CANCEL' | translate }}</button>
        <button class="btn-primary medium" (click)="confirm()" [disabled]="!(addressValue$ | async)">
          {{ 'OTHER.SELECT_AND_CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </div>
  <app-form-array-group
    [selectWidth]="92"
    [ngClass]="{ 'array-form': !selectCatalog?.hasGeo }"
    *ngLet="itemFields$ | async"
    [selectOptions]="itemFields"
    [isImpaired]="isImpaired"
    class="column-all"
    [groupData]="attributeGroupData"
    [showNewObject]="true"
    newTitle="SHARED_COMPONENTS.FORM_ARRAY_GROUP.ADD_NEW_ATTRIBUTE"
    newPlaceholder="SHARED_COMPONENTS.FORM_ARRAY_GROUP.PLACEHOLDER_VALUE_ATTRIBUTE"
    [showEmptyOption]="false"
  ></app-form-array-group>
</form>
